import Swiper, { Autoplay, Navigation, EffectFade } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let tsSwiperWr = document.querySelectorAll('.ts-swiper-wr');
tsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.slider-btn.next');
    let prevEl = el.querySelector('.slider-btn.prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, EffectFade],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      slidesPerView: 1,
      speed: 800,
      threshold: 10,
      autoHeight: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      effect: 'fade',
      fadeEffect:{
        crossFade: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    });
    swiperObserver(swiper);
  }
});
